export default __webpack_public_path__ + "static/media/calendar1.c6bb773f.svg";